export const USD = 'USD';
export const CAD = 'CAD';
export const EUR = 'EUR';
export const GBP = 'GBP';
export const RON = 'RON';
export const AUD = 'AUD';
export const DEFAULT_CURRENCY = USD;
